import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["clientIP", "correlationID", "offerID", "platform", "userID"];
// Types

// Utilities
import { v4 as uuid } from 'uuid';
let CORRELATION_ID;
export default class RECLog {
  constructor({
    clientIP,
    offerID,
    platform,
    ts = Math.round(Date.now() / 1000),
    type,
    userID,
    version
  }) {
    this.clientIP = void 0;
    this.correlationID = CORRELATION_ID || (CORRELATION_ID = uuid());
    this.offerID = void 0;
    this.platform = void 0;
    this.ts = void 0;
    this.type = void 0;
    this.uid = uuid();
    this.userID = void 0;
    this.version = void 0;
    this.clientIP = clientIP;
    this.offerID = offerID;
    this.platform = platform;
    this.ts = ts;
    this.type = type;
    this.userID = userID;
    this.version = version;
  }
  serialize() {
    const _this = this,
      {
        clientIP: client_ip,
        correlationID,
        offerID: offer_id,
        platform,
        userID: user_id
      } = _this,
      rest = _objectWithoutPropertiesLoose(_this, _excluded);
    return _extends({
      ['correlation-id']: correlationID,
      client_ip,
      offer_id,
      platform: platform.serialize(),
      user_id
    }, rest);
  }
}
//# sourceMappingURL=RECLog.js.map